import { AppColors } from "@/styles/colors";
import { Flex, Grid, GridItem, Text } from "@chakra-ui/react";
import { LegalOnboardingDetail } from "../schema/handler-functions";
import { CheckTermsAndConditionsActions } from "@/components/common/section-components/action/CheckTermsAndConditionsActions";

interface Props {
    detail: LegalOnboardingDetail | null;
    onOpenControlLog: () => void;
}

const toRespuesta = (value: unknown): string => {
    if (typeof value === "boolean") return value ? "Sí" : "No";
    return "-";
};

export const OBJValidationsCard = ({ detail, onOpenControlLog }: Props) => {
    const aceptoTerminos = Boolean(
        detail?.aceptaTerminosCondiciones ?? detail?.fechaAceptacionTerminos,
    );

    const rows = [
        {
            label: "Términos y Condiciones",
            respuesta: toRespuesta(aceptoTerminos),
            icon: aceptoTerminos ? (
                <CheckTermsAndConditionsActions
                    setOpenTermsAndConditionsModal={onOpenControlLog}
                />
            ) : undefined,
        },
        {
            label: "Verificación Servicio A13 ARCA",
            respuesta: toRespuesta(true),
        },
    ];

    return (
        <Flex
            flexDir="column"
            border={`1px solid ${AppColors.WHITE_BORDER_1}`}
            borderRadius="12px"
            marginBottom="12px"
        >
            <Text fontWeight={700} fontSize="12px" padding="20px" textTransform={"uppercase"} color={AppColors.GRAY_TEXT}>Validaciones</Text>
            <Grid templateColumns="repeat(2, 1fr)" width="100%">
                <GridItem paddingX="24px" paddingY="14px">
                    <Text
                        fontWeight={700}
                        fontSize={{ base: "11px", md: "12px", lg: "12px" }}
                        color={AppColors.GRAY_TEXT}
                    >
                        TIPO
                    </Text>
                </GridItem>
                <GridItem paddingX="24px" paddingY="14px">
                    <Text
                        fontWeight={700}
                        fontSize={{ base: "11px", md: "12px", lg: "12px" }}
                        color={AppColors.GRAY_TEXT}
                    >
                        RESPUESTA
                    </Text>
                </GridItem>
                {rows.map((row, index) => {
                    const backgroundColor =
                        index % 2 === 0 ? AppColors.BACKGROUND_SECONDARY : undefined;

                    return (
                        <Flex as="span" key={row.label} display="contents">
                            <GridItem
                                paddingX="24px"
                                paddingY="14px"
                                backgroundColor={backgroundColor}
                            >
                                <Text className="account-value-label">{row.label}</Text>
                            </GridItem>
                            <GridItem
                                paddingX="24px"
                                paddingY="14px"
                                backgroundColor={backgroundColor}
                            >
                                <Flex align="center" gap="8px">
                                    <Text className="account-value-label">{row.respuesta}</Text>
                                    {row.icon}
                                </Flex>
                            </GridItem>
                        </Flex>
                    );
                })}
            </Grid>
        </Flex>
    );
};
